import Image from 'next/image';
import { isItUndefined } from '../../util/DataUtil';
import VectorDown from '../icons/VectorDown';
import { useState } from 'react';

const AuthorInfoBlock = ({ children, key, isMobile }) => {
  const [open, setOpen] = useState(false);
  const html = isItUndefined(children.field_description) || '';
  const hasImage = !!children?.field_image?.webimage;

  const wordCount = html
    .replace(/<[^>]+>/g, '')
    .trim()
    .split(/\s+/).length;
  const isLongText = wordCount > 36;
  return (
    <div
      key={`author-info-block${key}`}
      className={`author-info ${!hasImage ? 'no-image' : ''}`}
    >
      {children?.field_image?.webimage ? (
        <div className="image-wrapper">
          <Image
            layout="fill"
            alt="author image"
            objectFit="cover"
            objectPosition="center"
            src={children?.field_image?.webimage}
          />
        </div>
      ) : null}
      <div
        className={`description ${isMobile && isLongText && !open ? 'is-collapsed' : ''}`}
        dangerouslySetInnerHTML={{
          __html: isItUndefined(children.field_description),
        }}
      />
      {isMobile &&
      isLongText &&
      !open &&
      isItUndefined(children.field_read_more_label) ? (
        <div className="read-more" onClick={() => setOpen(true)}>
          <span>{isItUndefined(children.field_read_more_label)}</span>
          <VectorDown />
        </div>
      ) : isMobile && isLongText && open ? (
        <div className="read-more less" onClick={() => setOpen(false)}>
          <span>{isItUndefined(children.field_see_less_label)}</span>
          <VectorDown />
        </div>
      ) : null}
    </div>
  );
};

export default AuthorInfoBlock;
